import { createFileRoute } from '@tanstack/react-router';

import Chart3D from '@/components/Chart3D';
import { ConfigureChartButton } from '@/components/ConfigureChartButton';
import { DownloadButton } from '@/components/DownloadButton';
import { RangeFilterButton } from '@/components/RangeFilterButton';
import { useChartTitle } from '@/contexts/ChartContext';
import { sixMaxOpeningData } from '@/data/sixMaxOpeningData';
import { useChartDefaults } from '@/hooks/useChartDefaults';
import { usePageActions } from '@/hooks/usePageActions';
import { buildChartHeadMeta } from '@/lib/headMeta';

export const Route = createFileRoute('/sixmax-opening')({
  component: SixMaxOpeningRoute,
  head: () => buildChartHeadMeta({ chartData: sixMaxOpeningData, ogImagePath: '/og/sixmax-opening.png' }),
});

function SixMaxOpeningRoute() {
  useChartTitle(sixMaxOpeningData);

  // Use categorical color scheme and show legend for this chart
  useChartDefaults({
    colorScheme: 'CATEGORICAL_5',
    showLegend: true,
    maxHeight: 2.5,
    useLogScale: false,
  });

  usePageActions({
    secondary: () => (
      <>
        <RangeFilterButton />
        <DownloadButton />
      </>
    ),
    primary: () => <ConfigureChartButton />,
  });

  return <Chart3D data={sixMaxOpeningData} />;
}
